import { useState, useRef, useEffect } from 'react';

/**
 * FishLayerBg — 鱼群层
 * 4 层共 19 条真实鱼 SVG，不同速度/透明度/方向
 */
export default function FishLayerBg() {
  const [fishes] = useState(() => {
    const layers = [
      { count: 5, sizeRange: [10, 14], speed: 10, opacity: [0.15, 0.3], yRange: [0.12, 0.32], direction: -1 },
      { count: 7, sizeRange: [12, 18], speed: 15, opacity: [0.2, 0.4], yRange: [0.22, 0.52], direction: 1 },
      { count: 4, sizeRange: [16, 24], speed: 22, opacity: [0.3, 0.55], yRange: [0.38, 0.65], direction: -1 },
      { count: 3, sizeRange: [20, 28], speed: 28, opacity: [0.4, 0.7], yRange: [0.5, 0.8], direction: 1 },
    ];

    const result = [];
    layers.forEach((layer, li) => {
      for (let i = 0; i < layer.count; i++) {
        result.push({
          id: `fish-${li}-${i}`,
          x: Math.random() * 100,
          y: layer.yRange[0] + Math.random() * (layer.yRange[1] - layer.yRange[0]),
          size: layer.sizeRange[0] + Math.random() * (layer.sizeRange[1] - layer.sizeRange[0]),
          opacity: layer.opacity[0] + Math.random() * (layer.opacity[1] - layer.opacity[0]),
          speed: layer.speed * (0.7 + Math.random() * 0.6),
          direction: layer.direction,
          wobblePhase: Math.random() * Math.PI * 2,
          wobbleSpeed: 0.4 + Math.random() * 1,
          wobbleAmp: 3 + Math.random() * 5,
        });
      }
    });
    return result;
  });

  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let lastTime = performance.now();
    let animId;

    const tick = (now) => {
      const dt = Math.min((now - lastTime) / 1000, 0.1);
      lastTime = now;
      const nodes = container.children;

      fishes.forEach((fish, i) => {
        fish.x += fish.direction * fish.speed * dt * 0.02;
        if (fish.x > 110) fish.x = -10;
        if (fish.x < -10) fish.x = 110;

        const wobble = Math.sin(now * 0.001 * fish.wobbleSpeed + fish.wobblePhase) * fish.wobbleAmp;

        const node = nodes[i];
        if (node) {
          node.style.transform = `translate3d(${fish.x}%, ${wobble}px, 0) scaleX(${fish.direction})`;
        }
      });

      animId = requestAnimationFrame(tick);
    };

    animId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(animId);
  }, [fishes]);

  return (
    <div ref={containerRef} className="absolute inset-0 overflow-hidden">
      {fishes.map((fish) => (
        <div
          key={fish.id}
          className="absolute will-change-transform"
          style={{
            top: `${fish.y * 100}%`,
            left: 0,
            width: `${fish.size}px`,
            height: `${fish.size * 0.5}px`,
            opacity: fish.opacity,
          }}
        >
          <img
            src="/assets/ocean/fish/fish-blue.svg"
            alt=""
            className="w-full h-full"
            style={{ objectFit: 'contain' }}
          />
        </div>
      ))}
    </div>
  );
}
